import { render, staticRenderFns } from "./GamesHeader.vue?vue&type=template&id=154bcbb8&scoped=true"
import script from "./GamesHeader.vue?vue&type=script&lang=js"
export * from "./GamesHeader.vue?vue&type=script&lang=js"
import style0 from "./GamesHeader.vue?vue&type=style&index=0&id=154bcbb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154bcbb8",
  null
  
)

export default component.exports